import { dataAccessEnvironment } from './data-access-environment';

export class JwtAuthHeaders {
  readonly Authorization: string;

  constructor() {
    this.Authorization = `Bearer ${dataAccessEnvironment.jwt}`;
  }
}
